// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eb54af70","455":"e431c964","977":"c8dfc76e"}[chunkId] + ".chunk.js";
};